import { createSlice } from "@reduxjs/toolkit";
import { RootState } from ".";
import { OuForm } from "../forms/Admin/OuForm";

export type OuAdminEditorState = {
    ouForm: OuForm;
    ouDataLoading: boolean;
    hasErrors: false;
}


export const initialState:OuAdminEditorState = {
    ouForm: new OuForm(),
    ouDataLoading: false,
    hasErrors: false
}

const ouAdminEditorSlice = createSlice({
    name: 'ouAdminEditor',
    initialState,
    reducers: {
        UpdateOuForm: (state, action: any) => {
            state.ouForm = action.payload;
            state.ouDataLoading = false;
        },
        CreateOuForm: (state, action: any) => {
            state.ouForm = action.payload;
            state.ouDataLoading = false;
        },
    },
    extraReducers: {},
  });


  export const { UpdateOuForm, CreateOuForm } = ouAdminEditorSlice.actions;

  // export ouAdminEditorSlice selector to get the slice in any component
export const ouAdminEditorSliceSelector = (state: RootState) => state.ouAdminEditor;
// export The reducer
const ouAdminEditorReducer = ouAdminEditorSlice.reducer;
export default ouAdminEditorReducer;